import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { DownloadService } from 'src/app/services/download.service';
import { InvoiceService } from 'src/app/services/invoice.service';

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.scss']
})
export class InvoiceListComponent implements OnInit {
  invoices = [];
  manualInvoices = [];
  prepaidManualInvoices = [];
  isLoading = true;
  manualInvoicesLoading = true;
  prepaidManualInvoicesLoading = true;
  data;
  frame = {
    page: 0
  }

  constructor(private invoiceService: InvoiceService, private download: DownloadService, private title: Title, private translate: TranslateService) { }

  ngOnInit(): void {
    this.getInvoices();
    this.getManualInvoices();
    this.getPrepaidManualInvoices();
    this.translate.get('title_invoices').subscribe({
      next: (title) => {
        this.title.setTitle(title);
      }
    });
  }

  downloadInvoice(invoice) {
    this.download.downloadInvoice(invoice).subscribe(data => {
      saveAs(data, 'invoice-no-' + invoice.invoice_number + '.pdf');
    });
  }

  downloadManualInvoice(invoice) {
    this.download.downloadManualInvoice(invoice).subscribe(data => {
      saveAs(data, invoice.original_name);
    });
  }

  downloadPrepaidManualInvoice(invoice) {
    this.download.downloadPrepaidManualInvoice(invoice).subscribe(data => {
      saveAs(data, invoice.original_name);
    });
  }

  onPaginate(event) {
    this.frame.page = event.page + 1;
    this.getInvoices();
  }

  private getInvoices() {
    this.invoiceService.getAllInvoices(this.frame).subscribe({
      next: (response) => {
        this.invoices = response.data.data;
        this.data = response.data;
      },
      complete: () => {
        this.isLoading = false;
      }
    })
  }

  private getManualInvoices() {
    this.invoiceService.getManualInvoices().subscribe({
      next: (response) => {
        this.manualInvoices = response.data.manual_invoices;
      },
      complete: () => {
        this.manualInvoicesLoading = false;
      }
    })
  }

  private getPrepaidManualInvoices() {
    this.invoiceService.getPrepaidManualInvoices().subscribe({
      next: (response) => {
        this.prepaidManualInvoices = response.data.manual_invoices;
      },
      complete: () => {
        this.prepaidManualInvoicesLoading = false;
      }
    });
  }
}
